import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'small' | 'normal' | 'large';
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  padding = 'normal',
  onClick
}) => {
  const paddingClasses = {
    none: '',
    small: 'p-3 sm:p-4',
    normal: 'p-4 sm:p-6',
    large: 'p-6 sm:p-8'
  };

  return (
    <div
      className={`
        bg-white dark:bg-gray-800
        rounded-lg
        shadow-sm
        transition-shadow
        duration-200
        hover:shadow-md
        ${paddingClasses[padding]}
        ${onClick ? 'cursor-pointer' : ''}
        ${className}
      `}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Card;